import { Type } from "class-transformer";
import { GenDoc } from "./gen-doc.model";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class GenDocDto {
    @Type(() => GenDoc)
    doc: GenDoc;
    tableColumns: OrdinaryObject = {};
}